<h2 mat-dialog-title>API Key Incorrect</h2>
    <mat-dialog-content>
        <p>The API key provided in the token parameter is incorrect</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>